import { Box, Stack, Typography, useTheme } from '@mui/material'
import { i18WithDefault as t } from '@shared/locale'
import { getInvoiceSubStatusColors } from 'components-ui/src/shared/invoices'
import { TCustomInvoiceDto } from 'service-api/src/types/general'

type InvoiceSubStatus = TCustomInvoiceDto['invoiceSubStatus']

const LEGEND_ENTRIES: { labelKey: string; subStatus: InvoiceSubStatus }[] = [
  { labelKey: 'calendar.legend.booked', subStatus: 'BOOKED' },
  { labelKey: 'calendar.legend.requested', subStatus: 'REQUESTED' },
  // TODO: implement Waitlist state
  // { labelKey: 'calendar.legend.waitlist', subStatus: 'PENDING_SCHEDULED' },
  { labelKey: 'calendar.legend.cancelled', subStatus: 'CANCELED' },
  { labelKey: 'calendar.legend.checkedOut', subStatus: 'COMPLETED' },
  { labelKey: 'calendar.legend.checkedIn', subStatus: 'IN_PROGRESS' },
]

export const BookingCalendarLegend = () => {
  const theme = useTheme()

  return (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      gap={2}
      role="list"
      aria-label={t('calendar.legend.label')}
    >
      {LEGEND_ENTRIES.map(({ labelKey, subStatus }) => {
        const { backgroundColor, color } = getInvoiceSubStatusColors(theme, { invoiceSubStatus: subStatus })

        return (
          <Stack key={labelKey} direction="row" alignItems="center" gap={0.75} role="listitem">
            <Box
              aria-hidden
              sx={{
                width: 16,
                height: 16,
                borderRadius: 0.5,
                flexShrink: 0,
                backgroundColor,
                border: `1px solid ${color}`,
              }}
            />
            <Typography variant="body2">{t(labelKey)}</Typography>
          </Stack>
        )
      })}
    </Stack>
  )
}
